// extracted by mini-css-extract-plugin
export default {"advertFooter":"mXX6gj0K"};